/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { StakingRewards } from "../StakingRewards";

export class StakingRewards__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _nexus: string,
    _stakingToken: string,
    _rewardsToken: string,
    _rewardsDistributor: string,
    overrides?: Overrides
  ): Promise<StakingRewards> {
    return super.deploy(
      _nexus,
      _stakingToken,
      _rewardsToken,
      _rewardsDistributor,
      overrides || {}
    ) as Promise<StakingRewards>;
  }
  getDeployTransaction(
    _nexus: string,
    _stakingToken: string,
    _rewardsToken: string,
    _rewardsDistributor: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _nexus,
      _stakingToken,
      _rewardsToken,
      _rewardsDistributor,
      overrides || {}
    );
  }
  attach(address: string): StakingRewards {
    return super.attach(address) as StakingRewards;
  }
  connect(signer: Signer): StakingRewards__factory {
    return super.connect(signer) as StakingRewards__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakingRewards {
    return new Contract(address, _abi, signerOrProvider) as StakingRewards;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "RewardPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    constant: true,
    inputs: [],
    name: "DURATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimReward",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "exit",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "getRewardToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_reward",
        type: "uint256",
      },
    ],
    name: "notifyRewardAmount",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardsDistributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    name: "setRewardsDistribution",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
